import { SITE_GAME_NAME } from "../../../controls/constants";
import FlexLayout from "../../../controls/FlexLayout";
import { IconButton } from "../../../controls/TooltipControls";
import { PureComponentEx } from "../../../controls/ComponentEx";
import * as selectors from "../../../util/selectors";
import { SITE_ID } from "../../gamemode_management/constants";
import * as fuzz from "fuzzball";
import * as React from "react";
import { DropdownButton, ListGroup, ListGroupItem, MenuItem, } from "react-bootstrap";
class DownloadGameList extends PureComponentEx {
    render() {
        const { currentGames, t, games } = this.props;
        const notSelectedGames = games
            .filter((game) => currentGames.indexOf(game.id) === -1)
            .sort((lhs, rhs) => fuzz.ratio(currentGames[0], rhs.name) -
            fuzz.ratio(currentGames[0], lhs.name));
        return (React.createElement(FlexLayout, { type: "column" },
            React.createElement(FlexLayout.Fixed, { className: "game-list-container" },
                React.createElement(DropdownButton, { id: "game-list-add-button", title: t("Add"), onSelect: this.addGame }, notSelectedGames.map(this.renderGame))),
            React.createElement(FlexLayout.Fixed, null,
                React.createElement(ListGroup, { className: "archive-game-list" }, currentGames.map(this.renderSelectedGame)))));
    }
    renderGame = (game) => {
        return (React.createElement(MenuItem, { key: game.id, eventKey: game.id }, selectors.gameName(this.context.api.store.getState(), game.id)));
    };
    renderSelectedGame = (gameId, idx) => {
        const { t, currentGames } = this.props;
        const gameName = gameId === SITE_ID
            ? t(SITE_GAME_NAME)
            : selectors.gameName(this.context.api.store.getState(), gameId);
        return (React.createElement(ListGroupItem, { key: gameId, className: idx === 0 ? "primary-game" : undefined },
            gameName || gameId,
            React.createElement(IconButton, { icon: "remove", tooltip: t("Remove"), className: "btn-embed", "data-gameid": gameId, disabled: currentGames.length < 2, onClick: this.removeGame })));
    };
    addGame = (gameId) => {
        const { currentGames, id, onSetDownloadGames } = this.props;
        const validGameEntries = currentGames.filter((game) => !!game);
        onSetDownloadGames(id, [].concat(validGameEntries, [gameId]));
    };
    removeGame = (evt) => {
        const { currentGames, id, onSetDownloadGames } = this.props;
        const gameId = evt.currentTarget.getAttribute("data-gameid");
        const idx = currentGames.indexOf(gameId);
        const newGames = currentGames.slice(0);
        newGames.splice(idx, 1);
        if (newGames.length > 0) {
            onSetDownloadGames(id, newGames);
        }
    };
}
export default DownloadGameList;
